import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { Provider } from "react-redux";
import { store } from "./reducer/store";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./utils/queryClient";
import { SoftphoneProvider } from "./contexts/SoftphoneContext";
import { ModuleProvider } from "./contexts/ModuleContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { google_client_id } from "./config/google";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <AuthProvider>
          <QueryClientProvider client={queryClient}>
            <ModuleProvider>
              <SoftphoneProvider>
                <GoogleOAuthProvider clientId={google_client_id}>
                  <App />
                </GoogleOAuthProvider>
              </SoftphoneProvider>
            </ModuleProvider>
          </QueryClientProvider>
        </AuthProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);
